module.exports = __webpack_public_path__ + "img/view_btn_hover.955237c3.png";